import Box from "@mui/material/Box";
import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import { COLORS } from "../../themes/Base";

const CustomCheckboxIcon = (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: "8px",
      border: "1px solid #E4E8D3",
      background: "#FFF",
      boxSizing: "border-box",
    }}
  />
);

const CustomCheckboxCheckedIcon = (
  <Box
    sx={{
      width: 20,
      height: 20,
      borderRadius: "8px",
      background: COLORS.secondary,
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path
        d="M4.77497 9.09567L1.82935 6.15004L2.64047 5.33892L4.77497 7.47342L9.35947 2.88892L10.1706 3.70004L4.77497 9.09567Z"
        fill="white"
      />
    </svg>
  </Box>
);

export default function CustomCheckbox(props: CheckboxProps) {
  return <Checkbox icon={CustomCheckboxIcon} checkedIcon={CustomCheckboxCheckedIcon} {...props} />;
}
